import type {
  GlobalStateCommandFactory,
  GlobalUserState,
} from 'components/GlobalState/GlobalStateModel';

interface UpdateUserCommand {
  patch: Partial<GlobalUserState>;
}

export const updateUser: GlobalStateCommandFactory<UpdateUserCommand> =
  (cmdContext) => (command) => {
    cmdContext.updateState((draft) => {
      draft.user = {
        ...draft.user,
        ...command.patch,
      };
    });
  };
